var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDarkModeRollbackReportIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "-3 -3 36 36",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  x: -3,
  y: -3,
  fill: "#092c29",
  strokeWidth: 0,
  rx: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M7.2 5.7h12.6v3.6h-1.5v.598h1.5V13.5h-1.5v.602h1.5V15h-.6v-.3H7.8v2.402h6v.597H9.3v.602h3.9v.597H7.8V21h5.4v.602h-6V18.3h1.5v-.602H7.2v-3.597h1.5V13.5H7.2V9.898h1.5v-.597H7.2zm.6.6v2.4h11.4V6.3zm1.5 3v.598h8.4v-.597zm-1.5 1.2v2.398h11.4V10.5zm1.5 3v.602h8.4V13.5zm0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.695 15.43c.25.011.25.011.504.02.043.14.086.277.133.421.41.613.754.723 1.453.902.399.067.399.067.797-.253.156-.16.156-.16.316-.32.508.015.817.284 1.204.6-.153.75-.153.75-.274 1.114-.043.566.246.84.57 1.285v.301c.145-.004.286-.008.434-.008.469.008.469.008.77.156.085.399.109.797.148 1.204-.863.449-.863.449-1.2.449-.21 1.105-.21 1.105.141 2.129q.152.135.309.27c-.18.374-.367.702-.602 1.05-.75-.148-.75-.148-1.113-.273-.566-.04-.84.246-1.285.574h-.3q-.072.59-.15 1.199l-1.35.148-.16-.515c-.114-.29-.114-.29-.29-.531-.504-.215-.504-.215-1.05-.153q-.383.293-.75.602c-.532-.028-.75-.153-1.2-.45.02-.097.04-.19.059-.288.12-.758.156-1.231-.274-1.887l-.215-.285c-.172-.243-.172-.243-.172-.54-.191-.023-.386-.042-.59-.066-.59-.066-.59-.066-.757-.234-.024-.403-.008-.801 0-1.2.347-.101.691-.199 1.05-.3.204-.946.204-.946-.14-1.809-.106-.097-.207-.195-.313-.293.165-.437.27-.715.602-1.05.281.03.281.03.617.105.738.105 1.102-.102 1.688-.535.246-.168.246-.168.547-.168q-.013-.251-.02-.508c.023-.742.117-.836.863-.863m-1.875 3.468c-.675.954-.738 1.696-.62 2.852.265 1.008.925 1.582 1.8 2.102.945.312 1.836.253 2.746-.153.883-.484 1.293-1.16 1.606-2.097.156-1.09-.125-1.954-.75-2.852-.825-.79-1.622-.953-2.723-.941-.863.082-1.492.441-2.059 1.09m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.102 18.898c.617.313.941.563 1.199 1.204.105.75.078 1.34-.262 2.023-.492.543-.492.543-.937.676-.489.02-.489.02-.903 0v-.602l.422-.176c.524-.3.719-.46.93-1.023-.09-.566-.211-.82-.637-1.2-.539-.195-.8-.077-1.312.15l.296.152c-.027.343-.027.343-.148.75-.395.328-.625.449-1.145.449-.48-.203-.597-.43-.804-.903v-.597l.328.047c.59-.067.781-.368 1.172-.797.554-.278 1.191-.219 1.8-.153m0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1
  }
}));
export { SvgDarkModeRollbackReportIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/darkModeRollbackReportIcon.svg";